import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="skills"
export default class extends Controller {
  static targets = ["input", "hiddenContainer"]



  addSkill(event) {
    if (event.key === 'Enter' || event.keyCode === 13) {
      event.preventDefault()
      event.stopPropagation()
      event.stopImmediatePropagation()

      const skill = this.inputTarget.value.trim()

      if (skill) {
        this.createSkillTag(skill)

        // Clear the input field
        this.inputTarget.value = ''
        event.target.value = ''

        // Force a blur and focus to ensure the field is properly cleared
        this.inputTarget.blur()
        setTimeout(() => {
          this.inputTarget.focus()
        }, 10)
      }

      return false
    }
  }

  removeSkill(event) {
    event.preventDefault()
    const skill = event.target.dataset.skillsSkillName
    this.deleteSkillTag(skill)
  }

  createSkillTag(skill) {
    const skillId = `skill-${this.parameterize(skill)}`

    // Check if skill already exists
    if (document.getElementById(skillId)) {
      return
    }

    // Create skill tag UI
    const skillTag = document.createElement('div')
    skillTag.className = 'bg-indigo-100 text-indigo-800 px-2 py-1 rounded-md flex items-center'
    skillTag.innerHTML = `
      <span>${this.escapeHtml(skill)}</span>
      <button type="button"
              class="ml-1 text-indigo-500 hover:text-indigo-700"
              data-action="click->skills#removeSkill"
              data-skills-skill-name="${this.escapeHtml(skill)}">×</button>
    `
    this.inputTarget.parentNode.insertBefore(skillTag, this.inputTarget)

    // Create hidden field for form submission
    const hiddenField = document.createElement('input')
    hiddenField.type = 'hidden'
    hiddenField.name = 'candidate_document[skills][]'
    hiddenField.value = skill
    hiddenField.id = skillId
    this.hiddenContainerTarget.appendChild(hiddenField)
  }

  deleteSkillTag(skill) {
    const skillId = `skill-${this.parameterize(skill)}`

    // Remove hidden field
    const hiddenField = document.getElementById(skillId)
    if (hiddenField) {
      hiddenField.remove()
    }

    // Remove skill tag UI
    const skillTags = document.querySelectorAll('[data-action*="skills#removeSkill"]')
    skillTags.forEach(btn => {
      if (btn.dataset.skillsSkillName === skill) {
        btn.closest('div').remove()
      }
    })
  }

  parameterize(str) {
    return str.toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '')
  }

  escapeHtml(text) {
    const div = document.createElement('div')
    div.textContent = text
    return div.innerHTML
  }
}
